import { CustomTicketV2, Event, TicketType } from "@markit/common.types";
import React, { useMemo, useState } from "react";
import {
  atCapacityEventLabel,
  getRedeemedTicketsDistributedInGroup,
  getTotalTicketsDistributedInGroup,
  getTotalTicketsSoldInGroup,
} from "../../utils/eventUtils/eventUtils";
import { Colors } from "../../utils/colors";
import {
  abbreviateNumber,
  productItemLabel,
  truncateString,
} from "@markit/common.utils";
import useAsyncOnMount from "../../hooks/useAsyncEffectOnMount";

type EventAnalyticsTicketRowProps = {
  event: Event;
  userId: string;
  customTicket: CustomTicketV2;
};

export const EventAnalyticsTicketRow = (
  props: EventAnalyticsTicketRowProps
) => {
  const { event, userId, customTicket } = props;

  const [ticketsSold, setTicketsSold] = useState<number | null>(null);
  const [hostTicketsRedeemed, setHostTicketsRedeemed] = useState<number | null>(
    null
  );
  const [hostTicketsDistributed, setHostTicketsDistributed] = useState<
    number | null
  >(null);

  useAsyncOnMount(async () => {
    const [soldInGroup, hostRedeemedInGroup, hostDistributedInGroup] =
      await Promise.all([
        getTotalTicketsSoldInGroup(
          event.id,
          customTicket.id,
          userId,
          customTicket.type === TicketType.REQUEST
        ),
        getRedeemedTicketsDistributedInGroup(event.id, customTicket.id),
        getTotalTicketsDistributedInGroup(event.id, customTicket.id),
      ]);

    // Sold
    setTicketsSold(soldInGroup);
    // Free Tickets Redeemed
    setHostTicketsRedeemed(hostRedeemedInGroup);
    setHostTicketsDistributed(hostDistributedInGroup);
  });

  const displayCapacityAvailable = useMemo(
    () => customTicket.quantityAvailable !== 0,
    [customTicket.quantityAvailable]
  );

  const itemLabel = useMemo(
    () => productItemLabel(event.eventType),
    [event.eventType]
  );

  return (
    <div
      style={{
        color: Colors.BLACK,
        display: "flex",
      }}
    >
      <div style={{ fontSize: "24px", marginRight: "14px", minWidth: 45 }}>
        {ticketsSold === null || hostTicketsRedeemed === null
          ? "--"
          : abbreviateNumber(ticketsSold + hostTicketsRedeemed)}
      </div>
      <div>
        <div style={{ fontSize: "12px", marginBottom: "4px" }}>
          {truncateString(customTicket.label, 40, "... ")}
        </div>
        <div
          style={{
            color: Colors.GRAY1,
            fontSize: "12px",
            marginBottom: "4px",
          }}
        >
          {ticketsSold === customTicket.quantityAvailable &&
          ticketsSold !== 0 &&
          displayCapacityAvailable
            ? `${atCapacityEventLabel(event, customTicket)}: ` +
              (ticketsSold === null ? "--" : abbreviateNumber(ticketsSold)) +
              "/" +
              abbreviateNumber(customTicket.quantityAvailable)
            : "Used: " +
              (ticketsSold === null ? "--" : abbreviateNumber(ticketsSold!)) +
              (displayCapacityAvailable
                ? "/" + abbreviateNumber(customTicket.quantityAvailable)
                : "")}
        </div>
        <div style={{ color: Colors.GRAY1, fontSize: "12px" }}>
          Free {itemLabel.pluralCap} Redeemed:{" "}
          {hostTicketsRedeemed === null || hostTicketsDistributed === null
            ? "--"
            : hostTicketsRedeemed + "/" + hostTicketsDistributed}
        </div>
      </div>
    </div>
  );
};
